
    import Vue from 'vue';

    export default Vue.extend({
        head: {
			title: { inner: 'Your Tennis match history in one place', separator: '|', complement: 'Str8 Sets' },
            meta: [
				{ name: 'description', content: 'Whether it\'s competition or social tennis matches that you play, Str8 Sets records them all for you. Your tennis ability is the sum of all your tennis matches and now you can store that data directly in the Str8 Sets app.', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_match_diary' },
                { property: 'og:title', content: 'Your Tennis match history in one place | Str8 Sets' },
                { property: 'og:description', content: 'Whether it\'s competition or social tennis matches that you play, Str8 Sets records them all for you. Your tennis ability is the sum of all your tennis matches and now you can store that data directly in the Str8 Sets app.' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_match_diary' },
				{ name: 'twitter:title', content: 'Your Tennis match history in one place | Str8 Sets' },
                { name: 'twitter:description', content: 'Whether it\'s competition or social tennis matches that you play, Str8 Sets records them all for you. Your tennis ability is the sum of all your tennis matches and now you can store that data directly in the Str8 Sets app.' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_match_diary', id: 'canonical' }
			]
        }
    })
